import { render, staticRenderFns } from "./CreateNewMediaFolder.vue?vue&type=template&id=652c8b9a&scoped=true"
import script from "./CreateNewMediaFolder.vue?vue&type=script&lang=js"
export * from "./CreateNewMediaFolder.vue?vue&type=script&lang=js"
import style0 from "./CreateNewMediaFolder.vue?vue&type=style&index=0&id=652c8b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c8b9a",
  null
  
)

export default component.exports